import script from "./UncategorisedCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./UncategorisedCard.vue?vue&type=script&setup=true&lang=ts"

import "./UncategorisedCard.vue?vue&type=style&index=0&id=5da4cdc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da4cdc1"]])

export default __exports__